/**
 * 🌍 GLOBAL STANDART KOD (TÜM PROJELER İÇİN GEÇERLİDİR)
 *
 * Bu dosya QubePro ekosisteminde ortak (global) standarttır.
 * Tek kaynak `qubepro-core` reposudur; uydu repolarda kalıcı değişiklik yapılmaz.
 * Değişiklik gerekiyorsa Core'da güncellenir ve senkron ile diğer repolara yayılır.
 */

/**
 * Çeviri Hook'u
 *
 * Dinamik olarak TranslationContext üzerinden veritabanı + statik dosya
 * birleşimini kullanır.
 */

import { useContext } from 'react';
import { TranslationContext } from '../context/TranslationContext';
import { tr } from '../locales/tr';
import { SupportedLanguage } from '../utils/language.utils';

export function useTranslation(_language?: SupportedLanguage): Record<string, any> {
  const t = useContext(TranslationContext);

  // Eğer context dışında kullanılırsa veya henüz yüklenmediyse
  // statik TR dosyasını fallback olarak döndür
  // (Context zaten statik dosyayla initialize olduğu için bu nadir olur)
  if (!t) return tr as Record<string, any>;

  return t as Record<string, any>;
}
